module.exports = __webpack_public_path__ + "img/wifi.1361ce30.svg";